/* import __COLOCATED_TEMPLATE__ from './integrate.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type RouterService from '@ember/routing/router-service';

interface Args {
  onNext?: () => void;
  openSection?: string | null;
  setSection?: (section: string | null) => void;
}

export default class StandaloneFreshdeskDeployTicketsIntegrate extends Component<Args> {
  @service declare router: RouterService;

  @tracked isUpdatingFinAgent = false;

  @action
  setSection(section: string | null) {
    if (this.args.setSection) {
      this.args.setSection(section);
    }
  }

  @action
  goToWorkflow() {
    if (this.args.onNext) {
      this.args.onNext();
    } else {
      this.router.transitionTo('apps.app.standalone.deploy.freshdesk.tickets.workflow');
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Freshdesk::Deploy::Tickets::Integrate': typeof StandaloneFreshdeskDeployTicketsIntegrate;
  }
}
